import { render, staticRenderFns } from "./AdviseRemoved.vue?vue&type=template&id=aa4e9ce2"
import script from "./AdviseRemoved.vue?vue&type=script&lang=js"
export * from "./AdviseRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports